import { FC, useEffect } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { HEADER_INPUT_ID } from 'src/shared-components/Header/Header';
import useModalStore from 'src/hooks/useModalStore';
import trns from './trns';
import Button, { ButtonColor, ButtonSize } from '../Button';

const searchIcon = 'shared/search.svg';
interface Props {
  withIcon?: boolean;
  small?: boolean;
  className?: string;
}

const SearchInput: FC<Props> = ({ small, withIcon, className }) => {
  const modalsConfig = useModalStore((state) => state.modalsConfig);
  const updateModalsConfig = useModalStore((state) => state.updateModalsConfig);

  useEffect(() => {
    if (modalsConfig['search-input-v2-modal']) {
      const headerInputElement = document.getElementById(HEADER_INPUT_ID);
      headerInputElement?.focus();
    }
  }, [modalsConfig['search-input-v2-modal']]);

  return (
    <div className={cn('relative w-full h-full flex', className)}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-row w-full bg-white border border-vermilion rounded-lg">
        <div className={cn(withIcon ? 'w-full' : 'w-9/12')}>
          <button
            // onClick and onChange are additional hooks to be sure member's focus is changed to header search
            onClick={() => {
              updateModalsConfig({ 'search-input-v2-modal': true });
            }}
            // Constant value to make it impossible to enter anything in this field
            className={cn(
              'rounded-lg',
              small ? 'pl-6 pr-1' : 'px-8',
              'outline-none w-full pt-2 pb-2 h-12 text-gray900 text-ellipsis fs-caption-reg'
            )}
          >
            <p className="flex italic fs-body-reg text-silver">
              <FormattedMessage {...trns.enterTitle} />
            </p>
          </button>
        </div>
        <Button
          color={ButtonColor.vermilion}
          size={ButtonSize.md}
          type="submit"
          innerClassName="rounded-l-none h-12"
          className={cn(
            'h-12 flex items-center shadow-none rounded-l-none rounded-r-md fs-body-reg uppercase z-20 bg-vermilion',
            !withIcon && 'w-3/12'
          )}
          label={
            withIcon ? (
              <div className="flex w-[30px] h-[30px]">
                <NextImage
                  alt="search icon"
                  src={searchIcon}
                  layout="fixed"
                  height={30}
                  width={30}
                  loading="eager"
                />
              </div>
            ) : (
              <FormattedMessage {...trns.searchCTA} />
            )
          }
        />
      </div>
    </div>
  );
};

export default SearchInput;
